export default __webpack_public_path__ + "static/media/4243.88396962.png";